export const sliceAlamat = (alamat) => {
    return alamat.slice(0, 35)
}